import React, {useEffect} from 'react';
import Loader from "../../common/Loader/Loader";

import './HubPage.scss';
import {useDispatch, useSelector} from "react-redux";
import {Redirect} from "react-router";
import {fetchUser} from "../../../reducers/auth";

const HubPage = () => {
  const userFetched = useSelector(state => state.auth.userFetched);
  const user = useSelector(state => state.auth.user);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!userFetched) {
      dispatch(fetchUser());
    }
    console.log(userFetched)
  }, [userFetched, dispatch]);
  if (userFetched) {
    if (user) {
      return (
        <Redirect to={'/dashboard'}/>
      );
    }
    return <Redirect to={'/login'}/>
  }

  return (
    <div className="HubPage" data-testid="HubPage">
      <div className="container">
        <div className="row">
          <div className="col">
            <div style={{height: 1000}}>
              <Loader/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default HubPage;
